import { Protocol } from '../library/constants'

export default function useSenders(sendSocketMessage: any) {
  const sendBet = (activeRisk: string, activeRows: number, stake: number) =>
    sendSocketMessage(Protocol.BET_POST, activeRisk, activeRows, stake)

  const requestBetReply = (id: string) =>
    sendSocketMessage(Protocol.GET_ROUND, id)

  const seedRequest = () => sendSocketMessage(Protocol.GET_SEEDS)

  const newSeedRequest = (s: string) => sendSocketMessage(Protocol.SET_SEED, s)

  return { sendBet, requestBetReply, seedRequest, newSeedRequest }
}
